import React from 'react';
import PropTypes from 'prop-types';
import {NumericFormat} from 'react-number-format';
function NumberFormatCustom(props) {
    let { inputRef, onChange,thousandSeparator,prefix, ...other } = props;
    let value=0;
    if(thousandSeparator===undefined) thousandSeparator = true;
    return (
        <NumericFormat
            {...other}
            getInputRef={inputRef}
            onChange={()=>{
                setTimeout(()=>{
                    onChange({
                        target: {
                            value: value,
                        },
                    });
                },0)
            }}
            onValueChange={values => {
                value = values.value
            }}
            thousandSeparator={thousandSeparator}
            prefix={prefix||""}
        />
    );
}
NumberFormatCustom.propTypes={
    inputRef:PropTypes.any,
    onChange:PropTypes.func,
}
export default NumberFormatCustom;